// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// Imports
// No uso gem "importmap-rails"; pero puedo emularlo de     esta manera.
// Antes de la carga de VUE, para que refresque con Vite    Ruby
// import "../application-imports.js"


// // Alpine.js for Maeraki UI Tailwindcss
// import Alpine from 'alpinejs'
// window.Alpine = Alpine
// Alpine.start()

// // Create Vue App
// import { createApp } from "vue";

// // Import App Component
// import App from "../vue/components/App.vue";

// // Router
// import router from '../vue/router/index.js';

// // Create Vue App
// const app = createApp(App);
// //const app = createApp()
// app.use(router);
// app.mount("#vue-app");

// Test new (simple app)



  // Vue App
  import { createApp } from "vue";
  import { createPinia } from 'pinia';

  // Test App
  // Small App para recrear los tests
  import Test from "../vue/components/tests/Test.vue";

  // Prueba App
  // Small App para rellenar los filtros previos a la prueba
  import  NewEditPruebaFiltros from "../vue/components/pruebas/NewEditFiltros.vue";

  // Filtros App
  // Small App para recrear los tests
  import Filtro from "../vue/components/filtros/Filtro.vue";
  import FiltroAdmin from "../vue/components/filtros/FiltroAdmin.vue";


  if(document.getElementById("test-app")  != null){
    // Create Vue App
    const pinia = createPinia();
    const test_app = createApp(Test);
    test_app.use(pinia);
    test_app.mount("#test-app");
  }

  if(document.getElementById("filtro-admin-app")  != null){
    // Create Vue App
    //const pinia = createPinia();
    const filtros_app = createApp(FiltroAdmin);
    //test_app.use(pinia);
    filtros_app.mount("#filtro-admin-app");
  }

  if(document.getElementById("filtro-app")  != null){
    // Create Vue App
    //const pinia = createPinia();
    const filtros_app = createApp(Filtro);
    //test_app.use(pinia);
    filtros_app.mount("#filtro-app");
  }
  
  if(document.getElementById("new-prueba-filtros-app")  != null){
    // Create Vue App
    //const pinia = createPinia();
    const filtros_app = createApp(NewEditPruebaFiltros);
    //test_app.use(pinia);
    filtros_app.mount("#new-prueba-filtros-app");
  }
